import * as React from "react";

import {translate} from "react-i18next";

// semantic-ui
import {Table} from "semantic-ui-react";

// redux
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

// components
import Button from "../../components/Button";
import Dialog from "../../components/Dialogs/Dialog";
import {IdentifierInputType} from "../../components/Table/dataHandler/Utils";

// services
import {
    TypefamilyDto,
    MenuDto,
    ResourceListOfTypefamilyDto,
    KumaRegionListDto,
    RegionDto,
    KumaViewDto,
    CnrDto,
    ResourceListOfModelyearDto,
    ModelyearDto,
    KumaCnrByRegionParams,
    ModeltypeBasicDto
} from "../../services/Client";
import ColumnFactory, {RegexFactory} from "../../services/ColumnFactory";

// helpers
import DataAdapterKumaView from "./DataAdapterKumaView";
import TextFieldRegEx from "../../components/TextFieldRegEx";
import HATEOASClient from "../../services/HATEOASClient";
import SelectField from "../../components/SelectField";
import TextField from "src/components/TextField";
import i18next from "i18next";

interface INewModeltypeDialogProps extends ITranslatedComponent {

    /** modeltype to be used to prefill the fields */
    templateItem?: DataAdapterKumaView;

    /**
     * called when the user clicks on create of new modeltype
     * @param value new modeltype to be created
     */
    onCreateNewModeltype?(value: DataAdapterKumaView): void;

    /**
     * called when the user clicks on cancel
     */
    onCancel?(): void;

    kumaExtraLinks?: MenuDto;

    client: HATEOASClient;

    userPSLModelyears: ResourceListOfModelyearDto;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    regions: KumaRegionListDto;
    typefamilies: ResourceListOfTypefamilyDto;
    kumaKefagList: string[];
    userCnrs: CnrDto[];
    derivates: ModeltypeBasicDto[];
}

interface INewModeltypeDialogState {
    /** currently creating new item */
    newItem:
    {
        item: DataAdapterKumaView;
        /** negative fields */
        [key: string]: any;
        selectedKefag: any;
    };

    inputType: IdentifierInputType;
    masterRegions: KumaRegionListDto;
    userCnrs: CnrDto[];
    derivatesModelYear: ModeltypeBasicDto[];
}
export const typefamilyRenderer = (typefamily: TypefamilyDto, t: i18next.TranslationFunction<any, object, string>) => t("GLOBAL:" + typefamily.key);
export const regionRenderer = (region: RegionDto) => region.name;
export const kefagRenderer = (kefag: string, t: i18next.TranslationFunction<any, object, string>) => t("KUMA_VIEW:" + kefag);
export const marketRenderer = (market: CnrDto) => market.name;
export const modelYearsRender = (modelyear: ModelyearDto) => modelyear.mj4 + '(' + modelyear.mj1 + ')';
export const userRenderer = (user: any) => `${user.name}`;
export const derivateRenderer = (derivate: ModeltypeBasicDto) => `${derivate.names && derivate.names[0].name} - ${derivate.modelyear.mj4}(${derivate.modelyear.mj1})`;

/**
 * shows the dialog to fill the properties for a new modeltype
 */
class NewKumaViewDialog extends React.Component<INewModeltypeDialogProps, INewModeltypeDialogState> {
    constructor(props: INewModeltypeDialogProps) {
        super(props);

        const templateItem = !props.templateItem ? undefined : ColumnFactory.deepCopy(props.templateItem.value);

        const dto = Object.assign(
            {},
            templateItem,
            {
                objectId: 0,
                versionId: 0,
            }
        );
        let negs: any = {
            titleNeg: dto.title === undefined,
            typefamilyNeg: dto.typefamilies === undefined,
            regionNeg: dto.regions === undefined,
            marketNeg: dto.assignedCnrs === undefined,
            architectureSystemsNeg: dto.architectureSystems === undefined
        };
        const selectedKefag: any = [];
        let upItem = new DataAdapterKumaView(dto as KumaViewDto);
        this.state = {
            newItem: {item: upItem, ...negs, ...selectedKefag},
            inputType: IdentifierInputType.MANUAL_INPUT,
            userCnrs: this.props.userCnrs,
            masterRegions: {},
            derivatesModelYear: this.props.derivates

        };
        this.handleNewModeltype = this.handleNewModeltype.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }
    private handleNewModeltype() {
        const {newItem} = this.state;
        if (this.props.onCreateNewModeltype) {
            let upItem = new DataAdapterKumaView(newItem.item.value);
            this.props.onCreateNewModeltype(upItem);
        }
    }

    private handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    private onRegionChange = async (selectedValue?: RegionDto[]) => {
        const {newItem, userCnrs} = this.state;
        let upItem = new DataAdapterKumaView(newItem.item.value);
        upItem.regions = selectedValue!.map((item: any) => item.selectedValue);
        if (upItem.regions && upItem.regions.find(p => p.objectId === 0) && this.props.regions.elements) {
            newItem.regionNeg = false;
            newItem.marketNeg = false;
            newItem.item.assignedCnrs = userCnrs.filter(p => p.objectId !== 0);
            newItem.item.regions = this.props.regions.elements.filter(p => p.objectId !== 0);
            this.setState({newItem});
            return;
        }
        upItem.assignedCnrs = [];
        newItem.item = upItem;
        if (selectedValue && selectedValue.length > 0) {
            newItem.marketNeg = false;
            newItem.regionNeg = false;
            const selectedRegionIds = upItem.regions.map(p => p.objectId);
            userCnrs.forEach(p => {
                if (p.region) {
                    if (selectedRegionIds.indexOf(p.region.id) !== -1) {
                        newItem.item.assignedCnrs.push(p);
                    }
                }
            });
        } else {
            newItem.marketNeg = true;
            newItem.regionNeg = true;
        }
        console.log(newItem);
        this.setState({newItem});
    }
    private onMarketChange = (selectedValue?: CnrDto[]) => {
        const {newItem} = this.state;
        let upItem = new DataAdapterKumaView(newItem.item.value);
        const getMarket = selectedValue!.map((values: any) => values.selectedValue);
        if (getMarket && getMarket.find(p => p.objectId === 0) && this.props.regions.elements) {
            upItem.assignedCnrs = this.state.userCnrs.filter(p => p.objectId !== 0);
            upItem.regions = this.props.regions.elements.filter(p => p.objectId !== 0);
            newItem.marketNeg = false;
            newItem.regionNeg = false;
            newItem.item = upItem;
            this.setState({newItem});
            return;
        }
        upItem.assignedCnrs = getMarket;
        newItem.item = upItem;
        newItem.marketNeg = !selectedValue || selectedValue.length === 0; // nothing selected
        const selectedMarketRegionIds = selectedValue!.map((values: any) => values.selectedValue.region.id);
        if (this.props.regions.elements) {
            const regionsIds = this.props.regions.elements.map(p => p.objectId);
            const removeIds: Array<number> = [];
            regionsIds.forEach((element: any) => {
                if (selectedMarketRegionIds.indexOf(element) === -1) {
                    removeIds.push(element);
                }
            });
            newItem.item.regions = this.props.regions.elements.filter(p => removeIds.indexOf(p.objectId) === -1);
            this.setState({newItem});
        }

    }

    private getFilterDerivateFromNewItem = () => {
        const {newItem} = this.state;
        const selectedTypeFamiliesNames = newItem.item.typefamilies.map((item: any) => item.selectedValue.name.trim());
        const selectedModelYearsObjIds = newItem.item.modelyears.map((item: any) => item.selectedValue.objectId);
        if (selectedModelYearsObjIds.length > 0 && selectedTypeFamiliesNames.length > 0) {
            const getDerivateBasedOnTypeFamily = this.props.derivates.filter((derivate) => selectedTypeFamiliesNames.includes(derivate.typefamily.name.trim()));
            const getDerivateBasedOnModelYear = getDerivateBasedOnTypeFamily.filter((derivate) => selectedModelYearsObjIds.indexOf(derivate.modelyear.objectId) !== -1);
            return getDerivateBasedOnModelYear;
        } else if (selectedTypeFamiliesNames.length > 0 && selectedModelYearsObjIds.length === 0) {
            const getDerivateBasedOnTypeFamily = this.props.derivates.filter((derivate) => selectedTypeFamiliesNames.includes(derivate.typefamily.name.trim()));
            return getDerivateBasedOnTypeFamily;
        } else if (selectedModelYearsObjIds.length > 0 && selectedTypeFamiliesNames.length === 0) {
            const getDerivateBasedOnModelYear = this.props.derivates.filter((derivate) => selectedModelYearsObjIds.indexOf(derivate.modelyear.objectId) !== -1);
            return getDerivateBasedOnModelYear;
        }
        return this.props.derivates;
    }
    render() {
        const {t, userPSLModelyears, typefamilies, regions, kumaKefagList} = this.props;
        const {newItem, userCnrs} = this.state;
        // not filled mandatory fields should be true
        const {titleNeg = true, typefamilyNeg = true, regionNeg = true, architectureSystemsNeg = true, marketNeg = true} = newItem;
        const actions =
            [
                <Button key={1} icon={"checkmark"} disabled={titleNeg || typefamilyNeg || regionNeg || architectureSystemsNeg || marketNeg} onClick={this.handleNewModeltype} />,
                <Button key={2} icon={"ban"} onClick={this.handleCancel} />,
            ];
        const typefamiliesList = typefamilies.elements || [];
        const regionList = regions.elements || [];

        return (
            <Dialog
                title={t("NEW_REQUIREMENT")}
                open={true}
                actions={actions}
                fullWidth={false}
            >
                <Table basic='very'>
                    <Table.Body>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{this.props.t("KUMA_VIEW:NAME")}<b>*</b></Table.HeaderCell>
                            <Table.Cell negative={titleNeg}>
                                <TextFieldRegEx
                                    id={'name-txt'}
                                    regex={RegexFactory.regex.name}
                                    value={this.state.newItem.item.title}
                                    onChange={(newValue: string, matchGroups: string[] | null, regExError?: string) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        upItem.title = newValue;
                                        newItem.item = upItem;
                                        newItem.titleNeg = matchGroups === null; // reg ex error
                                        this.setState({newItem});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:REGION")}<b>*</b></Table.HeaderCell>
                            <Table.Cell negative={regionNeg}>
                                <SelectField
                                    clearable={true}
                                    multi={true}
                                    dataSource={regionList}
                                    value={newItem.item.regions}
                                    rendererKey={regionRenderer}
                                    disabled={newItem.item.regions && newItem.item.regions.find(p => p.objectId === 0) !== undefined}
                                    onChange={this.onRegionChange}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:MARKET")}<b>*</b></Table.HeaderCell>
                            <Table.Cell negative={marketNeg}>
                                <SelectField
                                    clearable={true}
                                    multi={true}
                                    dataSource={userCnrs}
                                    value={this.state.newItem.item.assignedCnrs}
                                    rendererKey={marketRenderer}
                                    disabled={newItem.item.assignedCnrs && newItem.item.assignedCnrs.find(p => p.objectId === 0) !== undefined}
                                    onChange={this.onMarketChange}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:KEFAG")}<b>*</b></Table.HeaderCell>
                            <Table.Cell negative={architectureSystemsNeg}>
                                <SelectField
                                    clearable={false}
                                    multi={true}
                                    dataSource={kumaKefagList}
                                    rendererKey={(props: any) => kefagRenderer(props, t)}
                                    disabled={this.state.inputType !== IdentifierInputType.MANUAL_INPUT}
                                    onChange={(selectedValue?: any) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        newItem.selectedKefag = selectedValue!;
                                        upItem.architectureSystems = selectedValue!.map((item: any) => item.selectedValue).join(',');
                                        newItem.item = upItem;
                                        newItem.architectureSystemsNeg = !selectedValue || selectedValue.length === 0; // nothing selected
                                        this.setState({newItem});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:TYPEFAMILY")}<b>*</b></Table.HeaderCell>
                            <Table.Cell negative={typefamilyNeg}>
                                <SelectField
                                    clearable={false}
                                    multi={true}
                                    dataSource={typefamiliesList}
                                    rendererKey={(props: TypefamilyDto) => typefamilyRenderer(props, t)}
                                    disabled={this.state.inputType !== IdentifierInputType.MANUAL_INPUT}
                                    onChange={(selectedValue?: TypefamilyDto[]) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        upItem.typefamilies = selectedValue!;
                                        newItem.item = upItem;
                                        newItem.typefamilyNeg = !selectedValue || selectedValue.length === 0; // nothing selected
                                        const filteredDerivates = this.getFilterDerivateFromNewItem();
                                        this.setState({newItem, derivatesModelYear: filteredDerivates.length > 0 ? filteredDerivates : this.props.derivates});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:MODELYEAR")}</Table.HeaderCell>
                            <Table.Cell>
                                <SelectField
                                    clearable={false}
                                    multi={true}
                                    dataSource={userPSLModelyears.elements || []}
                                    rendererKey={modelYearsRender}
                                    disabled={this.state.inputType !== IdentifierInputType.MANUAL_INPUT}
                                    onChange={(selectedValue?: any) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        upItem.modelyears = selectedValue!;
                                        newItem.item = upItem;
                                        const filteredDerivates = this.getFilterDerivateFromNewItem();
                                        this.setState({newItem, derivatesModelYear: filteredDerivates.length > 0 ? filteredDerivates : this.props.derivates});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:DERIVATES")}</Table.HeaderCell>
                            <Table.Cell>
                                <SelectField
                                    clearable={false}
                                    multi={true}
                                    dataSource={this.state.derivatesModelYear || []}
                                    rendererKey={derivateRenderer}
                                    disabled={this.state.inputType !== IdentifierInputType.MANUAL_INPUT}
                                    onChange={(selectedValue?: ModeltypeBasicDto[]) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        upItem.derivates = selectedValue!;
                                        newItem.item = upItem;
                                        this.setState({newItem});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={3}>{t("KUMA_VIEW:DETAILED_REQUIREMENT")}</Table.HeaderCell>
                            <Table.Cell>
                                <TextField
                                    multiLine={true}
                                    placeholder={this.props.t("COLUMN_FACTORY:")}
                                    value={this.state.newItem.item.detail}
                                    onChange={(event: React.FormEvent<{}>, newValue: string) => {
                                        let upItem = new DataAdapterKumaView(newItem.item.value);
                                        upItem.detail = newValue;
                                        newItem.item = upItem;
                                        this.setState({newItem});
                                    }}
                                />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
                <div><b>* {this.props.t("MANDATORY_FIELD")}</b></div>
            </Dialog>
        );
    }
}

export default translate(["KUMA_VIEW", "COLUMN_FACTORY"])(NewKumaViewDialog);



// WEBPACK FOOTER //
// ./src/views/KumaView/NewKumaViewDialog.tsx